import React from 'react';
import { Sparkles, Image, Folder, Images } from 'lucide-react';

export const getChatIcon = (type: string) => {
  const icons: Record<string, React.ReactElement> = {
    standalone: <Sparkles className="w-3 h-3 mr-1" />,
    image: <Image className="w-3 h-3 mr-1" />,
    collection: <Folder className="w-3 h-3 mr-1" />,
    series: <Images className="w-3 h-3 mr-1" />,
  };
  return icons[type] || <Sparkles className="w-3 h-3 mr-1" />;
};

export const getChatNavigationPath = (chat: any) => {
  switch (chat.type) {
    case 'standalone':
      return `/chat/${chat.id}`;
    case 'image':
      return `/art/${chat.targetId}/chat/${chat.id}`;
    case 'collection':
      return `/art/chat/${chat.id}?collectionId=${chat.targetId}`;
    case 'series':
      return `/art/chat/${chat.id}?seriesId=${chat.targetId}`;
    default:
      // Fallback to chat route for unknown types
      return `/chat/${chat.id}`;
  }
};

export const isChatActive = (chat: any, location: any) => {
  switch (chat.type) {
    case 'standalone':
      return location.pathname === `/chat/${chat.id}`;
    case 'image':
      return location.pathname === `/art/${chat.targetId}/chat/${chat.id}`;
    case 'collection':
    case 'series':
      return (
        location.pathname === '/art/chat' &&
        location.search.includes(`${chat.type === 'collection' ? 'collectionId' : 'seriesId'}=${chat.targetId}`) &&
        location.pathname.includes(`/chat/${chat.id}`)
      );
    default:
      return location.pathname === `/chat/${chat.id}`;
  }
};
